import React, { useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputNumber } from 'primereact/inputnumber';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button'; // Importe o Button

export const TabelaAdicionarNotas = ({ alunos, setAlunos, avaliacao }) => {
    const toast = useRef(null);
    
    // ESTADOS PARA CONTROLE MANUAL
    const [editingId, setEditingId] = useState(null); // ID da linha em edição
    const [notaTemp, setNotaTemp] = useState(null);   // Valor temporário

    // --- FUNÇÕES DE AÇÃO ---

    const iniciarEdicao = (rowData) => {
        setEditingId(rowData.id);
        setNotaTemp(rowData.notaAluno || 0);
    };

    const cancelarEdicao = () => {
        setEditingId(null);
        setNotaTemp(null);
    };

    const salvarEdicao = (rowData) => {
        // Validação antes de salvar
        if (notaTemp > avaliacao) {
            toast.current.show({ 
                severity: 'error', 
                summary: 'Valor inválido', 
                detail: `A nota não pode ser maior que ${avaliacao}` 
            });
            return;
        }

        // Atualiza a lista original (setAlunos)
        const novosAlunos = alunos.map(aluno => 
            aluno.id === rowData.id ? { ...aluno, notaAluno: notaTemp } : aluno
        );
        
        setAlunos(novosAlunos);
        setEditingId(null);
        setNotaTemp(null);
        
        toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Nota atualizada!' });
    };

    // --- TEMPLATES ---

    const notaAlunoBodyTemplate = (rowData) => {
        // Se esta linha estiver sendo editada, mostra o InputNumber
        if (editingId === rowData.id) {
            return (
                <InputNumber 
                    value={notaTemp} 
                    onValueChange={(e) => setNotaTemp(e.value)}
                    mode="decimal" 
                    minFractionDigits={2} 
                    maxFractionDigits={2}
                    min={0}
                    max={avaliacao} // Previne visualmente passar do máximo
                    autoFocus
                />
            );
        }
        
        // Se não, mostra apenas o texto formatado
        const valor = rowData.notaAluno || 0;
        return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(valor);
    };

    const acoesBodyTemplate = (rowData) => {
        if (editingId === rowData.id) {
            return (
                <div className="flex gap-2">
                    <Button icon="pi pi-check" className="p-button-rounded p-button-success p-button-text" onClick={() => salvarEdicao(rowData)} />
                    <Button icon="pi pi-times" className="p-button-rounded p-button-danger p-button-text" onClick={cancelarEdicao} />
                </div>
            );
        }

        return (
            <Button icon="pi pi-pencil" className="p-button-rounded p-button-info p-button-text" onClick={() => iniciarEdicao(rowData)} />
        );
    };

    // Templates de Texto (Mantidos do seu original)
    const codigoBodyTemplate = (rowData) => (
        <><span className="p-column-title"></span>{rowData.id}</>
    );

    const matriculaBodyTemplate = (rowData) => (
        <><span className="p-column-title"></span>{rowData.matriculaNome}</>
    );

    return (
        <div className="card">
            <Toast ref={toast} position="bottom-right" />

            <DataTable
                value={alunos}
                responsiveLayout="scroll"
                dataKey="id"
                paginator
                rows={20}
                className="p-datatable-sm"
            >
                <Column field="id" header="Matrícula" body={codigoBodyTemplate} style={{ width: '15%' }} />
                <Column field="matriculaNome" header="Nome do Aluno" body={matriculaBodyTemplate} />
                
                <Column 
                    header="Nota Aluno" 
                    body={notaAlunoBodyTemplate} 
                    style={{ width: '25%' }} 
                />

                <Column 
                    header="Ações" 
                    body={acoesBodyTemplate} 
                    exportable={false} 
                    style={{ width: '15%', textAlign: 'center' }}
                />
            </DataTable>
        </div>
    );
};